Customer.Dashboard ||= {}

class Customer.Dashboard.NoteView extends Backbone.View
  template: JST["backbone/templates/customer/ticket/detail/note"]
  className: 'clearfix'
  viewType: 'note'

  events:
    'click #save': 'onSave'
    'click #delete_note': 'onDelete'
    'click #change_note': 'onEdit'
    'keyup #text': '_keepCustomerSessionAlive'

  initialize: (@options = {}) ->
    # just set @options

  onSave: (event) ->
    @_keepCustomerSessionAlive()
    $text = @$el.find('#text')
    return if $text.val() == ''

    $save = @$el.find('#save')
    $saving = @$el.find('#saving')
    $save.hide()
    $saving.show()
    @model.save({content: $text.val()}, {
      wait: true
      success: =>
        $text.val('')
        $save.show()
        $saving.hide()
        @$el.find('.modal').modal('hide')
        setTimeout((=> @render()), 1000)
      error: =>
        console.log("Error saving note")
        $save.show()
        $saving.hide()
      }
    )

  onEdit: (event) ->
    @_keepCustomerSessionAlive()
    @_checkPermissions(=> @$el.find('#note' + @model.attributes.id).modal())

  onDelete: (event) ->
    @_keepCustomerSessionAlive()
    @_checkPermissions(@_warningDeleteMessage)

  _checkPermissions: (callback) ->
    if @model.userCanModify()
      callback()
    else
      @_warningModifyMessage()

  _warningModifyMessage: ->
    showError(I18n.t('customer.dashboard.conversations.details.notes.no_permissions'))

  _warningDeleteMessage: =>
    swal({
      title: I18n.t('customer.dashboard.conversations.details.notes.confirm_delete')
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      confirmButtonText: I18n.t('customer.dashboard.conversations.details.notes.yes_delete')
      cancelButtonText: I18n.t('customer.dashboard.conversations.details.notes.no_cancel')
      closeOnConfirm: true
    }, => @destroy())

  render: ->
    note = @model.toJSON()
    user = @options.account_users[note.user_id]
    @$el.html(@template(note: note, user: user))
    return this

  updateVisibilityByPrivacy: (privacy) ->
    # do nothing

  closeResponseBox: ->
    # do nothing

  destroy: ->
    @model.destroy({data: {content: @model.get('content')}, processData: true})
    @remove()
    false

  removeReplyButton: ->
    # do nothing

  removeCutTicketButton: ->
    # do nothing

  _isLastOngoingSurveyInteraction: (model) ->
    false

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'

  externalIdClass: ->
    ''
